var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrganization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 4H12V2H5v2H2v18H0v1h11v-5h2v5h11v-1h-2zm-8 18v-5h-4v5H3V5h3V3h5v2h10v17zM5 11h4V7H5zm1-3h2v2H6zm4 3h4V7h-4zm1-3h2v2h-2zm4 3h4V7h-4zm1-3h2v2h-2zM5 16h4v-4H5zm1-3h2v2H6zm4 3h4v-4h-4zm1-3h2v2h-2zm4 3h4v-4h-4zm1-3h2v2h-2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganization);
export default __webpack_public_path__ + "static/media/organization.0289e3d81f06f06d86a2d5b8920cd73c.svg";
export { ForwardRef as ReactComponent };